import { useQuery } from 'react-query';
import { trackPromise } from 'react-promise-tracker';
import { getMetadataModel } from '..';
export const useGetMetadataModel = (additionlInfo) => useQuery(['GetMetadataModel', additionlInfo], () => trackPromise(getMetadataModel(additionlInfo)), {
    cacheTime: 0
});
